import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '../../../../components';
import styles from './MagicLink.module.scss';

type Props = {
  onClick: () => void;
};

export default memo(function MagicLink({ onClick }: Props) {
  const { t } = useTranslation('manual_upload_id');
  return (
    <div>
      <Typography className={styles.info}>{t('magic_link_info')}</Typography>
      <Button className={styles.button} type="submit" onClick={onClick}>
        {t('send_sms')}
      </Button>
      <p
        className={styles.hint}
        dangerouslySetInnerHTML={{
          __html: t('magic_link_hint'),
        }}
      />
    </div>
  );
});
